import 'css-chunksrc/client/common/weightTag/styles.scss';export default {
  "weightTag": "_weightTag_1x9wd_1",
  "red": "_red_1x9wd_9",
  "orange": "_orange_1x9wd_14",
  "mediumGreen": "_mediumGreen_1x9wd_19",
  "green": "_green_1x9wd_24"
};